export { default as wrapRootElement } from './src/root';
